import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  OnDestroy,
  Input,
} from "@angular/core";
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { RequesterService } from "../../services/requester.service";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { DataService } from "src/app/shared/services/data.service";
import { SharedRequesterService } from "src/app/shared/services/shared-requester.service";
import { UtilsService } from "src/app/shared/services/utils.service";
import {
  ExportDialogModel,
  ExportViewComponent,
} from "../export-view/export-view.component";
import { DatePipe } from "@angular/common";
import { startWith, map } from "rxjs/operators";
import { ManualOutliersRemovalComponent } from "../manual-outliers-removal/manual-outliers-removal.component";
// import { AdalService } from "adal-angular4";
import { Router } from "@angular/router";
import { ROLES } from "src/app/shared/roleList/priorityRoleList";
import { TranslateService } from "@ngx-translate/core";
import { MsalService } from "@azure/msal-angular";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSelect as MatSelect } from "@angular/material/select";
import { MatOption as MatOption } from "@angular/material/core";

@Component({
  selector: 'app-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.scss'],
  standalone: false
})
export class ComparisonComponent implements OnInit, OnDestroy {
  @ViewChild("paramSelector") paramSelector: TemplateRef<any>;
  @ViewChild("customDateSelector") customDateSelector: TemplateRef<any>;
  @ViewChild("markAsOutlier") markAsOutlier: TemplateRef<any>;
  @Input() chartType;
  today = new Date();
  alreadySelectedForComparison: any = false;
  trendParamsNameList: any[] = [];
  trendParamsList: any[] = [];
  comparedParamsList: any[] = [];
  selectedGranularity: any = {};
  subscription: any;
  parameterSelectorForm: UntypedFormGroup;
  selectedTab = "time-series";
  selCustDate: any = {
    from: null,
    to: null,
    convertedFrom: null,
    convertedTo: null,
  };
  lineList: any[];
  lineListFilter: any[];
  machineList: any[];
  machineListFilter: any[];
  periodList: any[];
  skuList: any[];
  parametersList: any[];
  parametersListFilter: any[];
  dialogRef: any;
  selectedParam: any = {};
  selectedIndex = null;
  filteredList: any = {
    parameters: [],
    sku: [],
  };
  autoCompleteStatus: any = {
    parameter: false,
    sku: false,
  };
  filterUslLsl: any;
  filterRedZone: any;
  subscriptionUslLsl: any;
  user: any;
  authentication = true;
  userRole: any;
  clusterList: any[];
  clusterListFilter: any[];
  factoryList: any[];
  factoryListFilter: any[];
  factoryOffset: any;
  factorySelectedGA: any;
  factoryIdGA: string;
  chartfirstIndex: number;
  chartlastIndex: number;
  moreRecords: any;
  urlSplit: any = [];
  trends: any = false;
  paramMasterList: any[];
  maxTrends;
  operationType;
  selectedPoints: any;
  roles: any[] = ROLES;
  multiClusterRoleList = ["spc-support", "spc-ga", "spc-gm", "spc-reader"];
  customPeriodHint = {
    from: "",
    to: "",
  };
  multiCluster = false;
  isCapability: any = false;
  samplingGroup: any[] = [2, 3, 4, 5, 6, 7, 8];
  outlierType = new Map();
  currentLanguage: any;
  dfosLineName: any;
  lastFifteenDays: any;
  lastFifyPoints: any;
  lastOneHour: any;
  historical: any;
  latestRUnSKU: any;
  public totalPoints: number = 0;
  public isPaginatorVisible: boolean = false;
  toggleStyle: any = [];
  popoverData: any;
  MarkAsOutlierOnwithobviousoutlier: boolean = true;
  MarkAsOutlierOnHistoricalData: boolean = true;
  isactiveSku = true;
  constructor(
    public dialog: MatDialog,
    public fb: UntypedFormBuilder,
    private requester: RequesterService,
    private sharedRequester: SharedRequesterService,
    private dataSer: DataService,
    public utilSer: UtilsService,
    private datePipe: DatePipe,
    private authService: MsalService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.urlSplit = this.router.url.split("/");
    this.checkUrl();
    this.subscription = dataSer.events.subscribe((res: any) => {
      if (res.name === "granularityChanged") {
        this.setGranularity();
        this.initializeVals();
        this.getClusters();
        this.trendParamsNameList = [];
        if (this.multiCluster) {
          this.setClusterFactoryValidator();
        }
      }
      if (res.name === "languageChanged") {
        this.currentLanguage = res.args[0];
        this.getLines();
        setTimeout(() => {
          this.lastOneHour = this.translate.instant('common.lastonehour'),
            this.lastFifteenDays = this.translate.instant('common.customdaterange'),
            this.historical = this.translate.instant('common.custom_data_historical'),
            this.lastFifyPoints = this.translate.instant('common.lastfiftypoints'),
            this.latestRUnSKU = this.translate.instant('menuList.latestrunsku'),
            this.initializeVals();
          this.skuList;
        }, 300);
      }
      if (res.name === "dfosLines") {
        this.dfosLineName = JSON.parse(res.args).data;
        this.getLines();
        //  this.changeDisplayOfLineName();
      }
    });

    this.subscriptionUslLsl = this.dataSer.events.subscribe((res: any) => {
      if (res.name === "usllslRedZoneChange") {
        this.comparedParamsList.forEach((element, i) => {
          element.filter.usl_lsl = this.isCapability
            ? false
            : JSON.parse(sessionStorage.getItem("usl_lsl"));
          element.filter.redZone = JSON.parse(
            sessionStorage.getItem("redZoneFilter")
          );
        });
      }
    });
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.comparedParamsList, event.previousIndex, event.currentIndex);
  }

  toggle(i) {
    this.toggleStyle[i] = !this.toggleStyle[i];
  }

  toggleAll(flag) {
    if (flag === "C") {
      this.toggleStyle.forEach((element, index) => {
        this.toggleStyle[index] = true;
      });
    } else {
      this.toggleStyle.forEach((element, index) => {
        this.toggleStyle[index] = false;

      });
    }
  }

  checkUrl() {
    if (
      this.urlSplit[7] === "comparison-trends" ||
      this.urlSplit[5] === "traceability"
    ) {
      this.trends = true;
      this.maxTrends = 4;
      if (this.urlSplit[5] === "traceability") {
        this.maxTrends = 6;
      }
    }
  }

  initializeVals() {
    this.factoryList = [];
    this.factoryListFilter = [];
    this.machineList = [];
    this.machineListFilter = [];
    this.comparedParamsList = [];
    this.periodList = [];
    this.parameterSelectorForm = this.fb.group({
      cluster: [""],
      factory: [""],
      line: ["", Validators.required],
      machine: ["", Validators.required],
      sampling: [5],
      period: ["", Validators.required],
      sku: ["", Validators.required],
      paramType: [
        this.trends || this.isCapability ? "continous" : "all",
        Validators.required,
      ],
      parameter: ["", Validators.required],
      parametersFilter: [[], Validators.required],
    });
    if (this.chartType === "xr") {
      this.isCapability = true;
      this.selectedTab = "x";
      this.isCapabilityCheck();
    }
    this.parameterSelectorForm.controls.period.disable();
    this.selCustDate = {
      from: null,
      to: null,
      convertedFrom: null,
      convertedTo: null,
    };
    const role = localStorage.getItem('userRole');
    this.userRole = role ? role : '';
    if (!this.multiClusterRoleList.includes(this.userRole)) {
      this.getLines();
    }
    //  this.getLines();
    this.setTrendValidator();
  }

  ngOnInit() {
    this.lastOneHour = this.translate.instant('common.lastonehour'),
      this.lastFifteenDays = this.translate.instant('common.customdaterange'),
      this.historical = this.translate.instant('common.custom_data_historical'),
      this.lastFifyPoints = this.translate.instant('common.lastfiftypoints'),
      this.latestRUnSKU = this.translate.instant('menuList.latestrunsku')
    this.initializeVals();
    this.setGranularity();
    this.filterParamsBasedOnInputChange();
    this.filterSKUsBasedOnInputChange();
    this.user = this.authService.instance.getActiveAccount();
    if (this.user && !this.user.idToken.roles) {
      this.authentication = false;
    } else {
      const role = localStorage.getItem('userRole');
      const profile = role ? [role] : [];
      this.userRole = this.dataSer.rolePrioritySetter(profile).length ? this.dataSer.rolePrioritySetter(profile)[0] : 'spc-read-only';
    }
    this.multiCluster = this.multiClusterRoleList.includes(this.userRole);
    if (this.multiCluster) {
      this.setClusterFactoryValidator();
    }
    this.getClusters();
    this.sharedRequester.setStartTimer();
    this.currentLanguage = JSON.parse(sessionStorage.getItem('languageMaster')).language;
    this.dfosLineName = JSON.parse(localStorage.getItem('dfosLines')).data;
  }

  filterParamsBasedOnInputChange() {
    this.filteredList.parameters =
      this.parameterSelectorForm.controls.parameter.valueChanges.pipe(
        startWith(""),
        map((value) =>
          this.utilSer.autoCompleteFilter(
            value,
            this.parametersList,
            "parametername"
          )
        )
      );
  }

  filterSKUsBasedOnInputChange() {
    this.isactiveSku = this.parameterSelectorForm.value.sku?.IsActive;
    this.filteredList.sku =
      this.parameterSelectorForm.controls.sku.valueChanges.pipe(
        startWith(""),
        map((value) =>
          this.utilSer.autoCompleteFilter(value, this.skuList, "skuName")
        )
      );
  }

  setGranularity() {
    this.selectedGranularity = {
      cluster: this.dataSer.getStorageData("selectedCluster")
        ? JSON.parse(this.dataSer.getStorageData("selectedCluster"))
        : {},
      factory: this.dataSer.getStorageData("selectedFactory")
        ? JSON.parse(this.dataSer.getStorageData("selectedFactory"))
        : {},
    };
  }

  getLines(initialCall?: boolean) {
    this.lineList = [];
    this.lineListFilter = [];
    this.machineList = [];
    this.machineListFilter = [];
    this.periodList = [
      {
        name: this.lastOneHour,
        code: "hour",
        value: 1,
      },
      {
        name: this.lastFifyPoints,
        code: "50points",
        value: "50points",
      },
      {
        name: this.lastFifteenDays,
        code: "comparison-custom",
        value: "last-15days",
      },
      {
        name: this.historical,
        code: "comparison-custom",
        value: "comparison-custom",
      },
    ];
    if (this.isCapability) {
      this.periodList.splice(1, 1);
    }
    this.sharedRequester
      .getLines(null, this.parameterSelectorForm.value.factory)
      .subscribe((response: any) => {
        if (response && response.length > 0) {
          response = this.utilSer.sortWrtCharAndNum(response, "linename");
          this.lineList = response;
          this.lineListFilter = response;
          this.utilSer.changeDisplayOfLineName(this.lineListFilter, this.currentLanguage, this.dfosLineName);

        }
      });
    // }
  }

  lineChanged() {
    this.machineList = [];
    this.machineListFilter = [];
    this.parametersList = [];
    this.parameterSelectorForm.controls.period.enable();
    this.getMachines();
    this.getSKUs();
    this.parameterSelectorForm.controls.parametersFilter.setValue([]);
    this.parameterSelectorForm.controls.period.setValue("");
  }

  periodChanged(ev) {
    if (
      ev &&
      ev.value &&
      (ev.value.code === "hour" || ev.value.code === "50points")
    ) {
      this.getSKUs();
    }
  }

  getMachines(initialCall?: boolean) {
    this.machineList = [];
    this.machineListFilter = [];
    this.parameterSelectorForm.controls.machine.setValue("");
    this.parameterSelectorForm.controls.parameter.setValue("");
    this.alreadySelectedForComparison = false;
    this.sharedRequester
      .getMachinesUnderLine(
        this.parameterSelectorForm.value.line,
        null,
        this.parameterSelectorForm.value.factory
      )
      .subscribe((machineResp: any) => {
        if (machineResp && machineResp.length > 0) {
          machineResp = this.utilSer.sortWrtCharAndNum(
            machineResp,
            "machinename"
          );
          this.machineList = machineResp;
          this.machineListFilter = machineResp;
          if (this.selectedParam && this.selectedParam.id) {
            // edit mode
            const selMachineFromEditDtls = this.findObjInArray(
              this.machineList,
              "machinename",
              this.selectedParam.machinename
            );
            if (selMachineFromEditDtls) {
              this.parameterSelectorForm.controls.machine.setValue(
                selMachineFromEditDtls
              );
              this.parametersList = [];
              this.parametersListFilter = [];
              this.getParamsUnderMachine();
            }
          }
        }
        if (machineResp.length === 1) {
          this.parameterSelectorForm.controls.machine.setValue(machineResp[0]);
          this.getParamsUnderMachine();
        }
      });
  }

  getSKUs(initialCall?: boolean) {
    this.skuList = [];
    this.parameterSelectorForm.controls.sku.setValue("");
    let lineID = "";
    if (
      this.parameterSelectorForm.value.line &&
      this.parameterSelectorForm.value.line.id
    ) {
      lineID = this.parameterSelectorForm.value.line.id;
    }
    this.sharedRequester
      .getSKUsWithinTimeRange(
        lineID,
        this.parameterSelectorForm.value.period,
        this.selCustDate,
        this.parameterSelectorForm.value.factory
      )
      .subscribe((skuResponse: any) => {
        if (!skuResponse || skuResponse.length === 0) {
          this.skuList = [];
          this.parameterSelectorForm.controls['sku'].markAsTouched();
          this.parameterSelectorForm.controls['sku'].setErrors({ 'noSkuFound': true });
          return;
        }
        const skuControl = this.parameterSelectorForm.controls['sku'];
        if (skuControl.hasError('noSkuFound')) {
          skuControl.setErrors(null);
          skuControl.updateValueAndValidity();
        }
        if (skuResponse) {
          skuResponse = skuResponse.sort((a, b) => b.startTimeEpoch - a.startTimeEpoch);
          if (
            this.parameterSelectorForm.value.period &&
            this.parameterSelectorForm.value.period.code) {
            this.skuList = [
              {
                skuName: this.latestRUnSKU,
                code: "allSKUs",
              },
              ...skuResponse,
            ];
            // } else if (
            //   this.parameterSelectorForm.value.period &&
            //   this.parameterSelectorForm.value.period.code === "hour" )
            //  {
            //   this.skuList = [
            //     {
            //       skuName: this.latestRUnSKU,
            //       code: "allSKUs",
            //     },
            //     ...skuResponse,
            //   ];
            if (this.skuList.length === 1) {
              this.parameterSelectorForm.controls.sku.setValue(this.skuList[0]);
              this.getParamsUnderMachine();
            }
          }

          else {
            this.skuList = skuResponse;

          }


          this.filterSKUsBasedOnInputChange();
          if (this.selectedParam && this.selectedParam.id) {
            // edit mode
            const assignedSKUText = this.trends
              ? this.selectedParam.skuDtls.skuName
              : this.selectedParam.assignedSKUText;
            if (
              assignedSKUText === "--" ||
              assignedSKUText === this.latestRUnSKU
            ) {
              this.parameterSelectorForm.controls.sku.setValue(this.skuList[0]);
            } else {
              this.parameterSelectorForm.controls.sku.setValue(
                this.findObjInArray(this.skuList, "skuName", assignedSKUText)
              );
            }
          }
        }
      });
    // }
  }

  getParamsUnderMachine() {
    this.parametersList = [];
    this.parametersListFilter = [];
    this.parameterSelectorForm.controls.parameter.setValue("");
    this.alreadySelectedForComparison = false;
    let paramFilterType = null;
    if (this.parameterSelectorForm.value.paramType === "batch") {
      paramFilterType = true;
    } else if (this.parameterSelectorForm.value.paramType === "continous") {
      paramFilterType = false;
    }
    this.parameterSelectorForm.controls.parametersFilter.setValue([]);
    // tslint:disable-next-line: max-line-length
    this.sharedRequester
      .getParametersUnderMachine(
        this.parameterSelectorForm.value.machine,
        paramFilterType,
        this.parameterSelectorForm.value.factory
      )
      .subscribe((paramResponse: any) => {
        if (paramResponse && paramResponse.length > 0) {
          paramResponse = this.utilSer.sortWrtCharAndNum(
            paramResponse,
            "parametername"
          );
          this.parametersList = paramResponse;
          this.parametersListFilter = paramResponse;
          this.filterParamsBasedOnInputChange();
          if (this.selectedParam && this.selectedParam.id) {
            // edit mode
            this.parameterSelectorForm.controls.parameter.setValue(
              this.findObjInArray(
                this.parametersList,
                "parametername",
                this.selectedParam.parametername
              )
            );
            if (this.trends) {
              this.parameterSelectorForm.controls.parametersFilter.setValue([]);
              this.parameterSelectorForm.controls.parametersFilter.setValue([
                this.parametersList[
                this.parametersList.findIndex(
                  (obj) => obj.id === this.selectedParam.id
                )
                ],
              ]);
            }
          }
        }
        this.setAutoCompleteStatus("sku", 'edit');
        if (paramResponse.length === 1) {
          setTimeout(() => {
            this.parameterSelectorForm.controls.parametersFilter.setValue([this.parametersList[0]]);
          }, 100);

        }
      });
  }

  removeParam(index) {
    this.comparedParamsList.splice(index, 1);
    this.dataSer.broadcast("replotGraph", true);
    this.selectedPoints = [];
  }

  onToggle(event) {
    this.selectedTab = event.value;
    this.setSelectedGraphType(this.selectedTab);
  }

  setSelectedGraphType(type) {
    this.selectedTab = type;
    if (
      this.isCapability &&
      this.comparedParamsList &&
      this.comparedParamsList.length
    ) {
      this.comparedParamsList.forEach((param) => {
        const clusterDtls = this.findObjInArray(
          this.clusterList,
          "clusterId",
          param.cluster
        );
        this.factoryList = clusterDtls.factories ? clusterDtls.factories : null;
        this.factoryListFilter = clusterDtls.factories
          ? clusterDtls.factories
          : null;
        const factoryDtls = this.findObjInArray(
          this.factoryList,
          "factoryId",
          param.factoryname
        );
        const chartfirstIndex = param.chartfirstIndex
          ? param.chartfirstIndex
          : null;
        const chartlastIndex = param.chartlastIndex
          ? param.chartlastIndex
          : null;
        this.getTimeSeriesData(
          param,
          param.assignedPeriodObj,
          param.sku,
          { id: param.lineid },
          factoryDtls,
          chartfirstIndex,
          chartlastIndex,
          param.assignedCustomPeriod
        );
      });
    }
  }

  toggleOutliers(item: any) {
    item.filter.usl_lsl = this.isCapability ? false : true;
    item.filter.rule1 = true;
    item.filter.rule6 = true;
    item.filter.rule7 = true;
    item.filter.outliers = !item.filter.outliers;
  }

  threewayApi(item, index, type) {
    if (type === "with-Outlier_" + index) {
      this.outlierType.set(item.id, 0);
    } else if (type === "with-ob-Outlier_" + index) {
      this.outlierType.set(item.id, 1);
    } else {
      this.outlierType.set(item.id, 2);
    }
    const lineDtsl = {
      id: item.lineid,
    };
    const factoryDtsl = {
      factoryId: item.factoryname,
    };
    this.selectedPoints = [];
    const sku = this.findObjInArray(
      this.skuList,
      "skuName",
      item.assignedSKUText
    );
    // item.chartfirstIndex = item.chartlastIndex + 1;
    // item.chartlastIndex = item.chartlastIndex + 300;
    this.getTimeSeriesData(
      item,
      item.assignedPeriodObj,
      sku,
      lineDtsl,
      factoryDtsl,
      item.chartfirstIndex,
      item.chartlastIndex,
      item.assignedCustomPeriod
    );
  }

  // threewayApi(item, type) {
  //   if (type.value === "with-Outlier") {
  //     this.outlierType.set(item.id, 0);
  //   } else if (type.value === "with-ob-Outlier") {
  //     this.outlierType.set(item.id, 1);
  //   } else {
  //     this.outlierType.set(item.id, 2);
  //   }

  //   const lineDtsl = {
  //     id: item.lineid,
  //   };
  //   const factoryDtsl = {
  //     factoryId: item.factoryname,
  //   };
  //   this.selectedPoints = [];
  //   const sku = this.findObjInArray(
  //     this.skuList,
  //     "skuName",
  //     item.assignedSKUText
  //   );
  //   // item.chartfirstIndex = item.chartlastIndex + 1;
  //   // item.chartlastIndex = item.chartlastIndex + 300;
  //   this.getTimeSeriesData(
  //     item,
  //     item.assignedPeriodObj,
  //     sku,
  //     lineDtsl,
  //     factoryDtsl,
  //     item.chartfirstIndex,
  //     item.chartlastIndex,
  //     item.assignedCustomPeriod
  //   );
  // }

  // threeWayBtn(data, event) {
  //   if (this.isCapability) {
  //     this.threewayApi(data, event);
  //   }
  //   data.filter.obiousOutlier = false;
  //   if (data.filter.outliers && event.value === "with-Outlier") {
  //     this.toggleOutliers(data);
  //   } else if (data.filter.outliers && event.value === "with-ob-Outlier") {
  //     data.filter.obiousOutlier = !data.filter.obiousOutlier;
  //     this.toggleOutliers(data);
  //   } else if (event.value === "without-Outlier") {
  //     this.toggleOutliers(data);
  //   } else if (event.value === "with-ob-Outlier") {
  //     data.filter.obiousOutlier = !data.filter.obiousOutlier;
  //   }
  // }



  threeWayBtn1(item, event, index) {
    if (this.isCapability) {
      this.threewayApi(item, index, event.currentTarget.id);
    }
    this.selectedPoints = [];
    item.filter.obiousOutlier = false;
    if (item.filter.outliers && event.currentTarget.id === "with-Outlier_" + index) {
      this.toggleOutliers(item);
    } else if (item.filter.outliers && event.currentTarget.id === "with-ob-Outlier_" + index) {
      item.filter.obiousOutlier = !item.filter.obiousOutlier;
      this.toggleOutliers(item);
    } else if (event.currentTarget.id === "without-Outlier_" + index) {
      this.toggleOutliers(item);
    } else if (event.currentTarget.id === "with-ob-Outlier_" + index) {
      item.filter.obiousOutlier = !item.filter.obiousOutlier;
    }

    if (!item.filter.outliers && !item.filter.obiousOutlier &&
      event.currentTarget.id === "with-Outlier_" + index && !event.currentTarget.checked) {
      item.filter.outliers = false;
      item.filter.obiousOutlier = false;
      (document.getElementById("with-Outlier_" + index) as HTMLFormElement).checked = true;
    } else if (!item.filter.outliers && item.filter.obiousOutlier &&
      event.currentTarget.id === "with-ob-Outlier_" + index && !event.currentTarget.checked) {
      item.filter.outliers = false;
      item.filter.obiousOutlier = true;
      (document.getElementById("with-ob-Outlier_" + index) as HTMLFormElement).checked = true;
    }
    /*******************************************Test */

    if (event.currentTarget.id === "with-ob-Outlier_" + index) {



      if (item.filter.obiousOutlier) {

        this.MarkAsOutlierOnwithobviousoutlier = false;

      }

    } else {

      this.MarkAsOutlierOnwithobviousoutlier = true;



    }
  }

  checkSelectedParam() {
    if (!this.trends) {
      this.alreadySelectedForComparison = this.comparedParamsList.some(
        (elem) => elem.id === this.parameterSelectorForm.value.parameter.id
      );
    }
  }

  setParamList(dtls?: any) {
    if (this.trends && this.selectedIndex !== -1) {
      this.trendParamsNameList.splice(this.selectedIndex, 1);
      this.parameterSelectorForm.value.parametersFilter.forEach((param) => {
        param.skuDtls = this.parameterSelectorForm.value.sku;
        this.trendParamsNameList.push(param);
      });
      this.trendParamsNameList.forEach((item) => {
        item.assignedPeriodObj = this.parameterSelectorForm.value.period;
      });
      this.comparedParamsList[0].parameterDtls = this.trendParamsNameList;
    }
    if (dtls === "edit") {
      this.editExistingParam();
    }
  }
  submitDtls() {
    if (this.selectedParam && this.selectedParam.id) {
      this.setParamList("edit");
      if (this.parameterSelectorForm.value.period.value == 'comparison-custom') {
        this.MarkAsOutlierOnHistoricalData = false;

      }
      else {
        this.MarkAsOutlierOnHistoricalData = true;

      }
    } else {
      this.addNewParam();
      this.setParamList();
      if (this.parameterSelectorForm.value.period.value == 'comparison-custom') {
        this.MarkAsOutlierOnHistoricalData = false;

      }
      else {
        this.MarkAsOutlierOnHistoricalData = true;


      }
    }

  }

  addNewParam() {
    this.checkSelectedParam();
    this.dialog.closeAll();
    if (this.trends) {
      if (this.comparedParamsList.length > 0) {
        this.parameterSelectorForm.value.parametersFilter.forEach((param) => {
          param.skuDtls = this.parameterSelectorForm.value.sku;
          param.assignedPeriodObj = this.parameterSelectorForm.value.period;
          this.comparedParamsList[0].parameterDtls.push(param);
        });
      } else {
        this.parameterSelectorForm.value.parametersFilter.forEach((item) => {
          item.skuDtls = this.parameterSelectorForm.value.sku;
          item.assignedPeriodObj = this.parameterSelectorForm.value.period;
        });
        this.comparedParamsList.push({
          parameterDtls: this.parameterSelectorForm.value.parametersFilter,
        });
      }
      this.formatResponseForParams(this.comparedParamsList[0]);
    } else {
      if (this.isCapability) {
        this.parameterSelectorForm.value.parameter.sampling =
          this.parameterSelectorForm.value.sampling;
      }
      this.comparedParamsList.push(
        this.formatResponseForParams(
          JSON.parse(JSON.stringify(this.parameterSelectorForm.value.parameter))
        )
      );
      this.toggleStyle.push(false);
      this.dataSer.broadcast("replotGraph", true);
      this.comparedParamsList.forEach((element, i) => {
        element.filter.usl_lsl = this.isCapability
          ? false
          : JSON.parse(sessionStorage.getItem("usl_lsl"));
        element.filter.redZone = JSON.parse(
          sessionStorage.getItem("redZoneFilter")
        );
      });
    }
    const parameter = this.trends
      ? this.comparedParamsList[0].parameterDtls
      : this.parameterSelectorForm.value.parameter;
    this.getTimeSeriesData(
      parameter,
      this.parameterSelectorForm.value.period,
      this.parameterSelectorForm.value.sku,
      this.parameterSelectorForm.value.line,
      this.parameterSelectorForm.value.factory
    );
  }

  editExistingParam(type?: any) {
    if (this.selectedIndex !== -1) {
      let parameter;
      parameter = this.trends
        ? this.comparedParamsList[0].parameterDtls
        : this.parameterSelectorForm.value.parameter;
      if (this.trends) {
        this.comparedParamsList[0].parameterDtls = this.trendParamsNameList;
      } else {
        this.comparedParamsList[this.selectedIndex] =
          this.formatResponseForParams(
            JSON.parse(
              JSON.stringify(this.parameterSelectorForm.value.parameter)
            )
          );
        this.comparedParamsList.forEach((element, i) => {
          element.filter.usl_lsl = this.isCapability
            ? false
            : JSON.parse(sessionStorage.getItem("usl_lsl"));
        });
        if (this.isCapability) {
          parameter.sampling = this.parameterSelectorForm.value.sampling;
          this.comparedParamsList[this.selectedIndex].sampling =
            this.parameterSelectorForm.value.sampling;

          this.outlierType.set(
            this.comparedParamsList[this.selectedIndex].id,
            0
          );
        }
      }
      this.getTimeSeriesData(
        parameter,
        this.parameterSelectorForm.value.period,
        this.parameterSelectorForm.value.sku,
        this.parameterSelectorForm.value.line,
        this.parameterSelectorForm.value.factory
      );
      this.selectedPoints = [];
      this.dialog.closeAll();
    }
  }

  formatResponseForParams(param) {
    param.filter = {
      usl_lsl: true,
      rule7: true,
      rule6: true,
      rule1: true,
      outliers: false,
      obiousOutlier: false,
    };
    if (this.parameterSelectorForm.value.sku.code === "allSKUs") {
      param.assignedSKUText = "--";
    } else {
      param.assignedSKUText = this.parameterSelectorForm.value.sku.skuName;
    }

    param.assignedPeriodObj = this.parameterSelectorForm.value.period;
    if (this.parameterSelectorForm.value.period.code === "comparison-custom") {
      param.assignedCustomPeriod = this.selCustDate;
    }

    param.selectedType = this.parameterSelectorForm.value.paramType;

    return param;
  }

  TagedPopOver(item) {
    this.popoverData = item;
    this.popoverData.fname = this.factoryListFilter.find(x => x.factoryId === this.popoverData.factoryname).name;
  }

  getTimeSeriesData(
    paramDtls,
    timeDtls,
    skuDtls,
    lineDtls,
    factoryDtls,
    chartfirstIndex?,
    chartlastIndex?,
    customDate?
  ) {
    let custDate;
    if (customDate) {
      custDate = customDate;
    } else {
      custDate = this.selCustDate;
    }
    chartfirstIndex = !this.trends
      ? chartfirstIndex
        ? chartfirstIndex
        : 0
      : this.chartfirstIndex;
    chartlastIndex = !this.trends
      ? chartlastIndex
        ? chartlastIndex
        : 299
      : this.chartlastIndex;
    this.trendParamsList = [];
    const Capability = {
      type: this.isCapability,
      subgroupSize: paramDtls.sampling,
      isRChart: this.selectedTab === "x" ? false : true,
      outlierType: this.outlierType.get(paramDtls.id)
        ? this.outlierType.get(paramDtls.id)
        : 0,
    };
    this.requester
      .getTimeSeriesData(
        paramDtls,
        timeDtls,
        skuDtls,
        lineDtls,
        custDate,
        true,
        this.trends,
        Capability,
        chartfirstIndex,
        chartlastIndex,
        null,
        factoryDtls
      )
      .subscribe((graphResponse) => {
        if (!graphResponse) {
          return;
        }
        const code: string = this.parameterSelectorForm.value.period.code;
        if (customDate || code === "comparison-custom") {
          this.comparedParamsList.forEach((element, i) => {
            if (paramDtls.id === element.id) {
              element.chartfirstIndex = chartfirstIndex ? chartfirstIndex : 0;
              element.chartlastIndex = chartlastIndex ? chartlastIndex : 299;
              if (!this.trends) {
                element.moreRecords = graphResponse.moreRecords;
                element.timeSeriesData = graphResponse.timeSeriesDatas;
                element.totalPoints = graphResponse.kpIs ? graphResponse.kpIs.totalDataPoints : 0;
              }
              element.selectedSku = {
                id: skuDtls ? skuDtls.skuId : null,
                name: skuDtls ? skuDtls.skuName : null,
              };
            }
          });
        }
        if (this.trends && graphResponse && graphResponse.tagDatas) {
          this.moreRecords = false;
          graphResponse.tagDatas.forEach((param: any) => {
            if (param.moreRecords) {
              this.moreRecords = param.moreRecords;
            }
          });
          this.setTrendData(graphResponse.tagDatas);
        } else {
          if (
            graphResponse &&
            graphResponse.timeSeriesDatas &&
            graphResponse.timeSeriesDatas.length
          ) {
            graphResponse.timeSeriesDatas.sort((a, b) => a.tsEpoch - b.tsEpoch);
            const index = this.isCapability
              ? this.comparedParamsList
                .map((item) => item.id)
                .indexOf(paramDtls.id)
              : this.selectedIndex;
            this.mapKPIsAndTimeSeries(
              index,
              graphResponse.timeSeriesDatas,
              graphResponse.kpIs,
              graphResponse.skuName
            );
          }
        }
        if (graphResponse.kpIs) {
          this.totalPoints = graphResponse.kpIs.totalPoints;
          this.totalPoints = this.totalPoints ? this.totalPoints : graphResponse.kpIs.totalDataPoints;
        }
        this.isPaginatorVisible = this.totalPoints > 0;
      });
  }

  mapKPIsAndTimeSeries(index, timeSeriesData, kpi, skuName) {
    timeSeriesData.forEach((element, i) => {
      if (this.isCapability) {
        const key = "k" + "" + i;
        element.convertedTS = key;
        element.batch = key;
        element.sp = null;
      } else {
        element.convertedTS = this.utilSer.timeStampConverter(
          element.tsEpoch * 1000,
          false
        );
      }
    });

    if (!this.comparedParamsList[index]) {
      return;
    }
    this.comparedParamsList[index].timeSeriesData = timeSeriesData;
    this.comparedParamsList[index].kpi = kpi;

    if (timeSeriesData.some((item) => item.manualOutlier)) {
      this.comparedParamsList[index].manualOutlierPresent = true;
    } else {
      this.comparedParamsList[index].manualOutlierPresent = false;
    }

    if (timeSeriesData.some((item) => !item.outlier)) {
      this.comparedParamsList[index].allOutliers = false;
    } else {
      this.comparedParamsList[index].allOutliers = true;
    }

    if (skuName && this.comparedParamsList[index].assignedSKUText === "--") {
      this.comparedParamsList[index].assignedSKUText = this.latestRUnSKU;
    }
  }

  setTrendData(trendData) {
    trendData.forEach((item) => {
      item.timeSeriesDatas.forEach((element) => {
        element.convertedTS = this.utilSer.timeStampConverter(
          element.tsEpoch * 1000,
          false
        );
      });
    });
    this.trendParamsList = trendData;
  }

  periodClick() {
    if (this.parameterSelectorForm.value.period.code === "comparison-custom") {
      this.dialogRef = this.dialog.open(this.customDateSelector, {
        width: "755px",
        height: "550px",
      });
      this.customPeriodHint.from = "";
      this.customPeriodHint.to = "";
    }
  }

  applyCustomToSelectedDate(evt) {
    this.selCustDate = {
      from: evt.from,
      to: evt.to,
      convertedFrom: new Date(
        this.utilSer.timeStampConverter(+evt.from, false)
      ),
      convertedTo: new Date(this.utilSer.timeStampConverter(+evt.to, false)),
    };
    this.dialogRef.close();

    this.getSKUs();
    this.chartfirstIndex = 0;
    this.chartlastIndex = 299;
    this.customPeriodHint.from = this.selCustDate.convertedFrom;
    this.customPeriodHint.to = this.selCustDate.convertedTo;
  }

  generateCSV(item: any) {
    let period;
    if (
      item.assignedPeriodObj &&
      item.assignedPeriodObj.code === "comparison-custom"
    ) {
      // tslint:disable-next-line: max-line-length
      period =
        this.datePipe.transform(
          item.assignedCustomPeriod.convertedFrom,
          "MMM d, y, HH:mm"
        ) +
        " - " +
        this.datePipe.transform(
          item.assignedCustomPeriod.convertedTo,
          "MMM d, y, HH:mm"
        );
    } else {
      period = item.assignedPeriodObj.name;
    }
    if (this.multiCluster) {
      const clusterDtls = this.findObjInArray(
        this.clusterList,
        "clusterId",
        item.cluster
      );
      this.factoryList = clusterDtls.factories ? clusterDtls.factories : null;
      const factoryDtls = this.findObjInArray(
        this.factoryList,
        "factoryId",
        item.factoryname
      );
      item.clusterFactoryDtls = {
        clusterName: clusterDtls ? clusterDtls.name : null,
        clusterId: clusterDtls ? clusterDtls.clusterId : null,
        factoryName: factoryDtls ? factoryDtls.name : null,
        factoryId: factoryDtls ? factoryDtls.factoryId : null,
      };
    } else {
      item.clusterFactoryDtls = {
        clusterName: JSON.parse(sessionStorage.getItem("selectedCluster"))
          ? JSON.parse(sessionStorage.getItem("selectedCluster")).name
          : null,
        clusterId: null,
        factoryName: JSON.parse(sessionStorage.getItem("selectedFactory"))
          ? JSON.parse(sessionStorage.getItem("selectedFactory")).name
          : null,
        factoryId: null,
      };
    }
    const dialogData = new ExportDialogModel(item, period, this.isCapability);
    this.dialog.open(ExportViewComponent, {
      width: "70%",
      height: "95%",
      panelClass: "export-dialog",
      data: dialogData,
    });
  }

  selectedPointsChange(points, item) {
    this.selectedPoints = points;
    this.selectedParam = item;
  }

  editComparedValues(param, index) {
    this.parameterSelectorForm.controls.period.enable();
    this.selectedIndex = index;
    this.dialog.open(this.paramSelector, {
      width: "450px",
      height: "620px",
      panelClass: "custom-comparison-dialog",
    });
    this.selectedParam = this.trends ? param.parameterDtls[index] : param;
    const linename = this.trends
      ? param.parameterDtls[index].linename
      : param.linename;
    const periodItem = this.trends
      ? param.parameterDtls[index].assignedPeriodObj.value
      : param.assignedPeriodObj.value;
    this.parameterSelectorForm.controls.paramType.setValue(param.selectedType);
    this.paramTypeChanged();
    this.parameterSelectorForm.controls.period.setValue(
      this.findObjInArray(this.periodList, "value", periodItem)
    );
    if (this.trends) {
      this.parameterSelectorForm.controls.parametersFilter.setValue([
        param.parameterDtls[index],
      ]);
    }
    if (this.isCapability) {
      this.parameterSelectorForm.controls.sampling.setValue(param.sampling);
    }
    if (this.multiCluster) {
      this.parameterSelectorForm.controls.cluster.setValue(
        this.findObjInArray(
          this.clusterList,
          "clusterId",
          this.selectedParam.cluster
        )
      );
      this.factoryList = this.parameterSelectorForm.value.cluster.factories;
      // tslint:disable-next-line: max-line-length
      this.parameterSelectorForm.controls.factory.setValue(
        this.findObjInArray(
          this.factoryList,
          "factoryId",
          this.selectedParam.factoryname
        )
      );
      this.sharedRequester
        .getLines(null, this.parameterSelectorForm.value.factory)
        .subscribe((resp: any) => {
          if (resp && resp.length > 0) {
            this.lineList = resp;
            this.lineListFilter = resp;
            this.parameterSelectorForm.controls.line.setValue(
              this.findObjInArray(this.lineList, "linename", linename)
            );
            this.getMachines();
            this.getSKUs();
            this.setAutoCompleteStatus("sku", true);
            this.setAutoCompleteStatus("parameter", true);
          }
        });
      this.customPeriodHint.from = param.assignedCustomPeriod
        ? param.assignedCustomPeriod.convertedFrom
        : null;
      this.customPeriodHint.to = param.assignedCustomPeriod
        ? param.assignedCustomPeriod.convertedTo
        : null;
    } else {
      this.parameterSelectorForm.controls.line.setValue(
        this.findObjInArray(this.lineList, "linename", linename)
      );

      this.getMachines();
      this.getSKUs();
      this.setAutoCompleteStatus("sku", true);
    }
  }

  selectNewParam(i) {
    const savedData = this.comparedParamsList;
    this.machineList = [];
    this.machineListFilter = [];
    this.skuList = [];
    this.lineList = [];
    this.lineListFilter = [];
    this.parametersList = [];
    this.parametersListFilter = [];
    this.selectedPoints = [];
    this.initializeVals();
    this.comparedParamsList = savedData;
    this.selectedParam = null;
    this.selectedIndex = i;
    this.dialog.open(this.paramSelector, {
      width: "450px",
      height: "620px",
      panelClass: "custom-comparison-dialog",
    });
  }

  afterOutlierSubmit(event, param) {
    if (event) {
      this.updateGraphOfSelectedParam(param);
      param.selectedPoints = [];
      this.selectedParam = null;
    }
    this.dialog.closeAll();
  }

  findObjInArray(arr: any[], keyToCheck: string, valueToCheck) {
    return arr.find((iteratedObj) => iteratedObj[keyToCheck] === valueToCheck);
  }

  mapParamName(param) {
    return param ? param.parametername : undefined;
  }

  public skuExists(value, arr) {
    if (value === "Latest Run") {
      return true;
    } else if (arr !== null) {
      return arr.some(function (el) {
        return el.skuname === value;
      });
    } else {
      return true;
    }
  }

  setAutoCompleteStatus(field, value) {
    this.isactiveSku = this.parameterSelectorForm.value.sku?.IsActive;
    this.filterParamsBasedOnInputChange();
    if (field === 'sku') {
      let skuTemp = this.parameterSelectorForm.controls.sku.value;
      if (value !== 'edit') {
        this.parameterSelectorForm.controls.parametersFilter.setValue([]);
        this.parameterSelectorForm.controls.parameter.setValue(null);
      }
      if (this.trends) {

        this.parametersListFilter = this.parametersList.filter((el: any) => {
          let skuFound = this.skuExists(skuTemp ? skuTemp.skuName : null, el.sku);
          if (skuFound) {
            return true;
          } else {
            return false;
          }
        });
      } else {

        this.parametersList = this.parametersListFilter.filter((el: any) => {
          let skuFound = this.skuExists(skuTemp ? skuTemp.skuName : null, el.sku);
          if (skuFound) {
            return true;
          } else {
            return false;
          }
        });
      }
    }

    this.autoCompleteStatus[field] = value;
  }

  updateGraphOfSelectedParam(param) {
    const clusterDtls = this.findObjInArray(
      this.clusterList,
      "clusterId",
      param.cluster
    );
    this.factoryList = clusterDtls.factories ? clusterDtls.factories : null;
    const selectedVals = {
      sku: this.findObjInArray(this.skuList, "skuName", param.assignedSKUText),
      line: { id: param.lineid },
      factory: this.findObjInArray(
        this.factoryList,
        "factoryId",
        param.factoryname
      ),
      period: param.assignedPeriodObj,
    };
    const chartfirstIndex = param.chartfirstIndex
      ? param.chartfirstIndex
      : null;
    const chartlastIndex = param.chartlastIndex ? param.chartlastIndex : null;
    if (this.multiCluster && !this.trends) {
      selectedVals.factory = this.findObjInArray(
        this.factoryList,
        "factoryId",
        param.factoryname
      );
      selectedVals.sku = {
        skuId: param.selectedSku ? param.selectedSku.id : null,
        skuName: param.selectedSku ? param.selectedSku.name : null,
      };
    }
    this.getTimeSeriesData(
      param,
      selectedVals.period,
      selectedVals.sku,
      selectedVals.line,
      selectedVals.factory,
      chartfirstIndex,
      chartlastIndex,
      param.assignedCustomPeriod
    );
  }

  removeManualOutliers(param, index) {
    this.selectedIndex = index;
    this.dialog
      .open(ManualOutliersRemovalComponent, {
        width: "450px",
        maxHeight: "550px",
        panelClass: "manualOutlierRemovalPopup",
        data: {
          pointsArr: param.timeSeriesData.filter((item) => item.manualOutlier),
          selParam: {
            id: param.id,
            tagname: param.tagname,
            linename: param.linename,
            assignedSKUText: param.assignedSKUText,
            assignedPeriodObj: param.assignedPeriodObj,
            batch: param.batch,
          },
        },
      })
      .afterClosed()
      .subscribe((selectedItem) => {
        if (selectedItem && selectedItem.id) {
          this.updateGraphOfSelectedParam(param);
        }
      });
  }

  paramTypeChanged() {
    if (this.isCapability) {
      this.periodList = [
        {
          name: this.lastOneHour,
          code: "hour",
          value: 1,
        },
        {
          name: this.lastFifteenDays,
          code: "comparison-custom",
          value: "last-15days",
        },
        {
          name: this.historical,
          code: "comparison-custom",
          value: "comparison-custom",
        },
      ];
      if (this.parameterSelectorForm.value.paramType === "batch") {
        this.periodList.splice(0, 1);
      }
    } else if (this.parameterSelectorForm.value.paramType === "batch") {
      this.periodList = [
        {
          name: "Last 50 Points",
          code: "50points",
          value: "50points",
        },
        {
          name: "Custom Date Range (Last 7 Days)",
          code: "comparison-custom",
          value: "last-15days",
        },
        {
          name: "Custom Date Range (Historical)",
          code: "comparison-custom",
          value: "comparison-custom",
          rangecode: "custom",
        },
      ];

      if (
        this.parameterSelectorForm.value.period &&
        this.parameterSelectorForm.value.period.code === "hour"
      ) {
        // special case >>> batch param & last 1 hour period -> clear SKU list and selected period
        this.parameterSelectorForm.controls.period.setValue(null);
        this.parameterSelectorForm.controls.sku.setValue(null);
        this.skuList = [];
      }
    } else {
      this.periodList = [
        {
          name: this.lastOneHour,
          code: "hour",
          value: 1,
        },
        {
          name: this.lastFifyPoints,
          code: "50points",
          value: "50points",
        },
        {
          name: this.lastFifteenDays,
          code: "comparison-custom",
          value: "last-15days",
        },
        {
          name: this.historical,
          code: "comparison-custom",
          value: "comparison-custom",
          rangecode: "custom",
        },
      ];
    }
    this.parameterSelectorForm.controls.period.setValue(null);
    this.parameterSelectorForm.controls.sku.setValue(null);
    this.skuList = [];
    if (
      this.parameterSelectorForm.value.line &&
      this.parameterSelectorForm.value.machine
    ) {
      this.getParamsUnderMachine();
    }
  }

  getClusters() {
    this.clusterList = [];
    this.clusterListFilter = [];
    this.parametersList = [];
    this.parametersListFilter = [];
    this.parameterSelectorForm.controls.parameter.setValue("");
    const savedClusterList = this.dataSer.getData("clusterList");
    if (savedClusterList && savedClusterList.length) {
      this.clusterList = savedClusterList;
      this.clusterListFilter = savedClusterList;
      this.assignDefaults();
    } else {
      this.sharedRequester.getClusters().subscribe((res: any[]) => {
        if (res && res['data'].length) {
          res['data'] = this.utilSer.replaceRegionClusterFactory(res);
          res['data'] = res['data'].map(v => ({ ...v, name: v.clusterName }));
          res['data'] = this.getFilteredData(res['data']);
          this.clusterList = res['data'].filter(
            (cluster) => cluster.factories && cluster.factories.length
          );
          this.clusterListFilter = res['data'].filter(
            (cluster) => cluster.factories && cluster.factories.length
          );
          this.assignDefaults();
        }
      });
    }
  }

  getFilteredData(clusters) {
    return this.clusterList = clusters.sort((a, b) => {
      const fa = a.clusterName?.toLowerCase();
      const fb = b.clusterName?.toLowerCase();
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    //  this.clusterList = clusters;
  }

  assignDefaults() {
    const cname: string = this.selectedGranularity.cluster ? this.selectedGranularity.cluster.name : '';
    const ob: any = cname ? this.findObjInArray(this.clusterList, 'name', cname) : {};
    this.parameterSelectorForm.controls.cluster.setValue(ob);
    this.getFactories();
  }

  getFactories() {
    this.skuList = [];
    this.lineList = [];
    this.lineListFilter = [];
    this.parametersList = [];
    this.parametersListFilter = [];
    this.machineList = [];
    this.machineListFilter = [];
    this.periodList = [];
    this.parameterSelectorForm.controls.period.setValue('');
    this.parameterSelectorForm.controls.sku.setValue('');
    this.parameterSelectorForm.controls.parameter.setValue('');
    this.parameterSelectorForm.controls.line.setValue('');
    this.parameterSelectorForm.controls.machine.setValue('');
    if (
      this.parameterSelectorForm.value.cluster &&
      this.parameterSelectorForm.value.cluster.factories
    ) {
      this.factoryList = this.parameterSelectorForm.value.cluster.factories.sort(
        (a, b) => {
          const fa = a.name.toLowerCase();
          const fb = b.name.toLowerCase();
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        }
      );
      this.factoryListFilter = this.factoryList;
    } else {
      this.factoryList = [];
      this.factoryListFilter = [];
    }
  }

  getFactoryOffset(factory) {
    this.skuList = [];
    this.parameterSelectorForm.controls.sku.setValue("");
    this.parametersList = [];
    this.parameterSelectorForm.controls.parameter.setValue("");
    this.parameterSelectorForm.controls.period.setValue("");
    this.parameterSelectorForm.value.factory = factory.value;
    this.sharedRequester
      .getFactoryOffset(this.parameterSelectorForm.value.factory)
      .subscribe((res) => {
        if (res && res.status === "Success") {
          this.factoryOffset = res.utcOffset;
        }
      });
    this.getLines();
  }

  removeTrendParam(item, ind) {
    this.selectedIndex = 0;
    const index = this.trendParamsNameList.findIndex(
      (obj) => obj.id === item.id
    );
    this.trendParamsNameList.splice(index, 1);
    this.trendParamsNameList.length
      ? this.editExistingParam("delete")
      : this.initializeVals();
  }

  setClusterFactoryValidator() {
    if (this.multiCluster) {
      this.parameterSelectorForm.controls[`cluster`].setValidators([
        Validators.required,
      ]);
      this.parameterSelectorForm.controls[`cluster`].updateValueAndValidity();
      this.parameterSelectorForm.controls[`factory`].setValidators([
        Validators.required,
      ]);
      this.parameterSelectorForm.controls[`factory`].updateValueAndValidity();
    } else {
      this.parameterSelectorForm.controls[`cluster`].clearValidators();
      this.parameterSelectorForm.controls[`cluster`].updateValueAndValidity();
      this.parameterSelectorForm.controls[`factory`].clearValidators();
      this.parameterSelectorForm.controls[`factory`].updateValueAndValidity();
    }
  }
  isCapabilityCheck() {
    if (this.isCapability) {
      this.parameterSelectorForm.controls[`sampling`].setValidators([
        Validators.required,
      ]);
      this.parameterSelectorForm.controls[`sampling`].updateValueAndValidity();
    } else {
      this.parameterSelectorForm.controls[`sampling`].clearValidators();
      this.parameterSelectorForm.controls[`sampling`].updateValueAndValidity();
    }
  }

  chartChange(item: any, index: number, type?: any) {
    this.selectedIndex = index;
    const lineDtsl: any = {
      id: item.lineid,
    };
    const factoryDtsl: any = {
      factoryId: item.factoryname,
    };
    this.selectedPoints = [];
    const sku: any = {
      skuId: item.selectedSku ? item.selectedSku.id : null,
      skuName: item.selectedSku ? item.selectedSku.name : null,
    };
    const last: number = index * 300 - 1;
    const first: number = index * 300 - 300;
    item.chartfirstIndex = first;
    item.chartlastIndex = last;
    this.getTimeSeriesData(
      item, item.assignedPeriodObj, sku, lineDtsl,
      factoryDtsl, item.chartfirstIndex, item.chartlastIndex, item.assignedCustomPeriod);
    /*if (type === "next") {
      item.chartfirstIndex = item.chartlastIndex + 1;
      item.chartlastIndex = item.chartlastIndex + 300;
      this.getTimeSeriesData(
        item, item.assignedPeriodObj, sku, lineDtsl,
        factoryDtsl, item.chartfirstIndex, item.chartlastIndex, item.assignedCustomPeriod      );
    } else if (type === "back" && item.chartfirstIndex > 0) {
      item.chartlastIndex = item.chartfirstIndex - 1;
      item.chartfirstIndex = item.chartfirstIndex - 300;
      this.getTimeSeriesData(
        item, item.assignedPeriodObj, sku, lineDtsl,
        factoryDtsl, item.chartfirstIndex, item.chartlastIndex, item.assignedCustomPeriod      );
    }*/
  }
  setTrendValidator() {
    if (this.trends) {
      this.setAutoCompleteStatus("parameter", true);
      this.parameterSelectorForm.controls[`parameter`].clearValidators();
      this.parameterSelectorForm.controls[`parameter`].updateValueAndValidity();
      this.parameterSelectorForm.controls[`parametersFilter`].setValidators([
        Validators.required,
      ]);
      this.parameterSelectorForm.controls[
        `parametersFilter`
      ].updateValueAndValidity();
    } else {
      this.parameterSelectorForm.controls[`parameter`].setValidators([
        Validators.required,
      ]);
      this.parameterSelectorForm.controls[`parameter`].updateValueAndValidity();
      this.parameterSelectorForm.controls[`parametersFilter`].clearValidators();
      this.parameterSelectorForm.controls[
        `parametersFilter`
      ].updateValueAndValidity();
    }
  }

  paginationChange(ind, type) {
    this.selectedIndex = 0;
    if (type === "next") {
      this.chartfirstIndex = this.chartlastIndex + 1;
      this.chartlastIndex = this.chartlastIndex + 300;
      this.editExistingParam();
    } else if (type === "back" && this.chartfirstIndex > 0) {
      this.chartlastIndex = this.chartfirstIndex - 1;
      this.chartfirstIndex = this.chartfirstIndex - 300;
      this.editExistingParam();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionUslLsl.unsubscribe();
    const page = this.trends ? "Traceability-Trends" : "SPC-Comparison charts";
    this.sharedRequester.userAnalytics({ screenName: page });
  }

  openMarkAsOutlierPopup(item, index) {
    this.selectedIndex = index;
    if (this.selectedParam.id === item.id) {
      this.dialogRef = this.dialog.open(this.markAsOutlier, {
        width: "400px",
        height: "360px",
      });
    }
  }

  machineChanged() {
    this.parameterSelectorForm.controls.period.setValue("");
    this.parameterSelectorForm.controls.sku.setValue("");
  }
}
